import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Hero3 from "./hero/Hero3";
import Hero2 from "./hero/Hero2";
import Hero1 from "./hero/Hero1";

export default function Hero() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
  };
  return (
    <div className=" w-full">
      <Slider {...settings}>
        <Hero3 />
        <Hero2 />
        <Hero1 />
      </Slider>
    </div>
  );
}
